import { FC, useState } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { HTHBuildingModal } from 'src/components/_commons/house-to-house';
import { hthHelper } from 'src/services';
import { typeHTHBuilding, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useGetConfig } from 'src/custom-hooks';

type propsType = {
    building: typeHTHBuilding;
    currentFace: typeHTHFace;
    territoryNumber: typeTerritoryNumber;
};

export const HTHFaceBuildingsItem: FC<propsType> = ({ building, currentFace, territoryNumber }) => {
    const [show, setShow] = useState(false);
    const config = useGetConfig();

    const closeBuildingModalHandler = (): void => setShow(false);

    return (
        <>
        <div className={'text-center my-3'}>
            <button key={building.streetNumber}
                className={`btn ${!!hthHelper.GetFreeHouseholds(building) ? 'btn-general-blue' : 'btn-general-red'} d-inline mx-auto py-2 my-2`}
                style={{ width: '280px' }}
                onClick={() => setShow(true)}
            >
                {currentFace.street} {building.streetNumber}{building.streetNumber2 ? `/${building.streetNumber2}` : ''}{building.streetNumber3 ? `/${building.streetNumber3}` : ''} ({hthHelper.GetFreeHouseholds(building)} libres)
            </button>
            <div className={'form-check form-check-inline ms-3 me-0'}>
                <input type={'checkbox'}
                    className={'form-check-input share-building checkbox-md checkbox-red mt-0'}
                    // style={{ height: '20px', width: '20px' }}
                    value={`${building.streetNumber}${building.streetNumber2 ? `/${building.streetNumber2}` : ''}${building.streetNumber3 ? `/${building.streetNumber3}` : ''}`}
                />
                <label className={'form-check-label'} htmlFor="inlineCheckbox1"></label>
            </div>
            {!!building.dateOfLastSharing && generalHelpers.IsToday(building.dateOfLastSharing) &&
                <h6>
                    <span className={'bg-info'}>
                        (Ya compartido hoy)
                    </span>
                </h6>
            }
        </div>
        {show &&
            <HTHBuildingModal
                closeBuildingModalHandler={closeBuildingModalHandler}
                config={config}
                currentBuilding={building}
                currentFace={currentFace}
                territoryNumber={territoryNumber}
            />
        }
        </>
    );
}
